import React from "react";

import GetTheApp from "../Inputs/GetTheApp";
import { useState, useEffect } from "react";
import { motion, useScroll } from "motion/react";
import { useRef } from "react";
// The fade-in-focus effect pairs with the sticky image, which only exists on desktop
const isDesktop = () => window.matchMedia("(min-width: 1024px)").matches;

const ExploreItem = ({ title, sub, item1, item2, item3, item4, item5 }) => {
  return (
    <motion.div
      initial={false}
      animate={{ opacity: isDesktop() ? 0.7 : 1 }}
      whileInView={{ opacity: 1 }}
      viewport={{ amount: 0.9 }}
      className="w-full max-w-[600px]  flex justify-center items-center pt-3 pb-3   gap-10 "
    >
      <div className=" min-w-[35%] max-w-[479px] pr-4">
        <h4 className="mt-2 3xl:my-2 font-[500] text-[#131E3D]  text-[26px] 3xl:text-[38px] 4xl:text-[42px] leading-[32.94px] 3xl:leading-[40.94px] 4xl:leading-[44.94px] ">
          {title}
        </h4>
        <h5 className=" font-[400] mt-4 text-[#6D6E73]  text-[14px] 3xl:text-[16px] 4xl:text-[20px] leading-[16.94px] 3xl:leading-[18.2px] 4xl:leading-[24.2px] ">
          {sub}
        </h5>
        <h5 className=" font-[500] mt-6 text-[#131E3D]  tracking-[-1] text-[14px] 3xl:text-[20px] 4xl:text-[24px] leading-[20.94px] 3xl:leading-[27.2px] 4xl:leading-[31.2px] ">
          What do I get?
        </h5>
        <div className="mt-4">
          {[item1, item2, item3, item4, item5].map((item, i, items) => (
            <div key={i} className="flex gap-[8px]">
              {/* Timeline: rows grow with their text so long items never overlap */}
              <div className="flex flex-col items-center shrink-0">
                <div
                  className={`h-[6px] w-[1px] ${i > 0 ? "bg-[#F1EDFB]" : ""}`}
                ></div>
                <div className="bg-[#F1EDFB] rounded-full w-[10px] h-[10px] "></div>
                {i < items.length - 1 && (
                  <div className="flex-1 w-[1px] bg-[#F1EDFB] "></div>
                )}
              </div>
              <h5 className="min-h-[50px] pb-3 font-[450] text-[#131E3D]  tracking-[-1] text-[15px] 3xl:text-[16px] 4xl:text-[16px]  3xl:leading-[17.8px] 4xl:leading-[20.8px] ">
                {item}
              </h5>
            </div>
          ))}
        </div>
        <GetTheApp className="mt-4 4xl:mt-6" location={`Explore - ${title}`} />
      </div>
    </motion.div>
  );
};

export default ExploreItem;
